import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary, H4, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';
import { Tooltip } from '@liveauctioneers/hammer-ui-core/tooltip';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

export type RankProps = {
    isMobile: boolean;
    name: string;
    popoverHeader: string;
    popoverText: string;
};

export const Rank = ({
    isMobile,
    name = 'ranking.accName',
    popoverHeader = 'header',
    popoverText = 'popoverText',
}: RankProps) => {
    // Due to how the props work, we need to use the base useIntl.formatMessage
    // Ideally, we would have the props for name, popoverHeader, and popoverText
    // be more limited than what they are, but for now, leaving this as working
    // with just a raw string.
    const { formatMessage } = useIntl();

    return (
        <div
            className={cn({
                'mx-sm self-center': isMobile,
                'mx-lg my-sm w-[100px] mdMax:max-w-[70px] xsMax:max-w-[unset]': !isMobile,
            })}
        >
            <div
                className="flex w-[85px] cursor-pointer flex-col content-center items-center xsMax:w-[16%]"
                id="rank-badge-trigger"
            >
                <div className="mb-2xs flex h-[60px] w-[60px] items-center justify-center rounded-full border border-border-secondary">
                    <img
                        alt="trophy"
                        className="mt-2xs h-[28px] w-[28px]"
                        height="28"
                        src="https://p1.liveauctioneers.com/dist/images/trophy.svg"
                        width="28"
                    />
                </div>
                <H4 className="text-center">{formatMessage({ id: name })}</H4>
            </div>
            <Tooltip
                anchorSelect="#rank-badge-trigger"
                place="bottom"
            >
                <LabelStrong>{formatMessage({ id: popoverHeader })}</LabelStrong>
                <BodySecondary>{formatMessage({ id: popoverText })}</BodySecondary>
            </Tooltip>
        </div>
    );
};
